import { useState, useEffect } from "react";
import "../../styles/Sponsors.css";
import Zeus from "../../assets/sponsors/zeus.png";
import Ayudaqr from "../../assets/sponsors/ayudaqr.png";
import Collarqr from '../../assets/sponsors/collarqr.png';
import Momenti from '../../assets/sponsors/momenti.png';
import TurnosGol from '../../assets/sponsors/turnosgol.png';
import RemindQr from '../../assets/sponsors/remindqr.png';
//import Solutimax from '../../assets/sponsors/solutimax.png';

const sponsors = [
  // {
  //   src: Solutimax,
  //   link: "https://www.solutimaxsrl.com.ar",
  //   type: "Web",
  //   description: "Empresa dedicada a servicios de herrería, plomería, albañilería y pintura, entre otros servicios."
  // },
  {
    src: Collarqr,
    link: "https://www.collarqr.com.ar",
    type: "Web",
    description: "Ofrece collares con código QR para una identificación rápida de mascotas."
  },
  {
    src: Ayudaqr,
    link: "https://www.ayudaqr.com.ar",
    type: "Web",
    description: "Plataforma que utiliza códigos QR para ayudar a personas que la necesiten."
  },
  {
    src: Momenti,
    link: "https://www.momenti.com.ar",
    type: "Web",
    description: "Empresa que ofrece servicios de tarjetas digitales, sonido, luces, decoración y más para eventos."
  },
  {
    src: TurnosGol,
    link: "https://www.turnosgol.com.ar",
    type: "Web",
    description: "Sistema digital especializado en la gestión de reservas de canchas de fútbol."
  },
  {
    src: RemindQr,
    link: "https://www.remindqr.com.ar/",
    type: "Web",
    description: "Transforma un mensaje de voz en objetos únicos que se reproducen al instante con solo escanear."
  },
  {
    src: Zeus,
    link: "https://www.zeusagencia.com",
    type: "Web",
    description: "Agencia dedicada a desarrollo web, marketing digital, diseño gráfico, asistentes con ia, etc."
  }
];

export const Sponsors = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sponsors.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="sponsors-container">
      <h1>Sponsors:</h1>
      <div className="carousel">
        {sponsors.map((sponsor, index) => (
          <a 
            key={index} 
            href={sponsor.link} 
            target="_blank" 
            rel="noopener noreferrer"
            className="carousel-link"
          >
            <img
              src={sponsor.src}
              alt={`Sponsor ${index + 1}`}
              className={index === currentIndex ? "active" : "hidden"}
              style={{
                animation: index === currentIndex 
                  ? 'slideInFromRight 1s ease' 
                  : ''
              }}
            />
          </a>
        ))}
      </div>

      {/* ✅ DESCRIPCIÓN COMO SPAN — SOLO VISIBLE EN EL ACTIVO */}
      <span 
        className={`sponsor-description ${
          currentIndex !== -1 ? 'visible' : 'hidden'
        }`}
      >
        {sponsors[currentIndex].description}
      </span>

      {/* Puntitos indicadores */}
      <div className="carousel-dots">
        {sponsors.map((_, index) => (
          <span 
            key={index} 
            className={`dot ${index === currentIndex ? "active-dot" : ""}`}
          ></span>
        ))}
      </div>

      {/* Mensaje según el tipo de enlace */}
      <div className="sponsor-url">
        <p>
          <a href={sponsors[currentIndex].link} target="_blank" rel="noopener noreferrer">
            Ir a {sponsors[currentIndex].type}
          </a>
        </p>
      </div>
    </div>
  );
};